import type { CastBounds } from "./locations";

export const CAST_SITE_HALF_W_PX = 112;
export const CAST_SITE_BOX_H_PX = 64;
export const CAST_PART_HALF_W_PX = 100;
/** Nested part chip below a site box (gap + padding; see locations.css). */
export const CAST_NESTED_STACK_BELOW_PX = 56;

export function castLocationStackBounds(
  siteX: number,
  topY: number,
  stackAbove: boolean,
  nestedPartCount: number,
): CastBounds {
  const nested =
    nestedPartCount > 0 ? CAST_NESTED_STACK_BELOW_PX : 0;
  const top = stackAbove ? topY - CAST_SITE_BOX_H_PX : topY;
  const bottom = stackAbove ? topY + nested : topY + CAST_SITE_BOX_H_PX + nested;
  return {
    minX: siteX - CAST_SITE_HALF_W_PX,
    minY: top,
    maxX: siteX + CAST_SITE_HALF_W_PX,
    maxY: bottom,
  };
}

export function mergeCastBounds(
  bounds: CastBounds | null,
  next: CastBounds,
): CastBounds {
  if (bounds === null) {
    return next;
  }
  return {
    minX: Math.min(bounds.minX, next.minX),
    minY: Math.min(bounds.minY, next.minY),
    maxX: Math.max(bounds.maxX, next.maxX),
    maxY: Math.max(bounds.maxY, next.maxY),
  };
}

export function mergeCastPartRow(
  bounds: CastBounds | null,
  anchorX: number,
  partDx: number,
  top: number,
  bottom: number,
): CastBounds {
  const x = anchorX + partDx;
  return mergeCastBounds(bounds, {
    minX: x - CAST_PART_HALF_W_PX,
    minY: top,
    maxX: x + CAST_PART_HALF_W_PX,
    maxY: bottom,
  });
}
